<template>
  <div class="comment-item">
    <div class="comment-author">
      <img
        :src="`${$base_api}/${item.user.avatar}`"
        alt="avatar"
        class="avatar"
      >
    </div>
    <div class="comment-body">
      <div class="comment-head">
        <p class="text-bold">
          {{ item.user ? item.user.name : 'N/A' }}
        </p>
        <p class="text-muted">
          {{ $moment(item.created_at).format('DD/MM/YYYY hh:mm:ss A') }}
        </p>
      </div>
      <p>{{ item.comment }}</p>
      <div>
        <ul v-if="Array.isArray(item.files)">
          <li
            v-for="(file, key) in item.files"
            :key="key"
          >
            <a
              :href="`${$base_api}/${file.src}`"
              target="_blank"
            >{{ file.filename }}</a>
          </li>
        </ul>
      </div>
      <template v-if="action && user && user.id === item.user_id">
        <div class="d-flex justify-items-end">
          <button
            v-if="can([Permissions.backend.comment.edit])"
            class="btn btn-primary btn-xs mr-2"
            data-target="#editCommentModal"
            data-toggle="modal"
            @click="onEdit"
          >
            <i class="fa fa-edit" />
          </button>
          <button
            v-if="can([Permissions.backend.comment.delete])"
            class="btn btn-danger btn-xs"
            @click="onDelete"
          >
            <i class="fa fa-trash-o" />
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Permissions from '@/permissions'

export default {
  name: 'CommentItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    action: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      Permissions
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.data
    })
  },
  methods: {
    onEdit () {
      this.$store.commit('comment/toggleEditCommentModal')
      this.$store.commit('comment/setCommentUuid', this.item.uuid)
    },
    onDelete () {
      this.onConfirm().then((accept) => {
        if (accept) {
          this.$isLoading(true)
          this.$axios.post(this.$base_api + '/api/v4/backend/comment/delete', {
            comment_uuid: this.item.uuid
          }).then(() => {
            this.$store.commit('comment/setRefreshCommentList')
            this.onDeleted()
          }).catch((error) => {
            this.onResponseError(error)
          }).finally(() => {
            this.$isLoading(false)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

.comment-item {
  display: grid;
  grid-template-columns: 50px 1fr;
  background: #f7f7f7;
  padding: 6px;
  grid-gap: 10px;
  border-bottom: 0.05rem #dddddd solid;
}

.comment-item:last-child {
  border-bottom: none !important;
}

.comment-head {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.comment-body {
  overflow-wrap: anywhere;
}

ul {
  padding-left: 15px;
}
</style>
